import React, { useState, useEffect, useRef } from 'react';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import '../../../styles/components/_forms.scss';

import { useNotification } from '../../../hooks/useNotification';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { fetchClientById, fetchClientOfficeId, fetchClientsConcat, fetchOffices, insertDataClient, updateClient } from '../../../services/client.service';
import { IconButton, TextField, Tooltip } from '@mui/material';
import { CreateFormClient } from '../../../components/client/CreateFormClient';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient';
import { LocationClient } from '../../../components/client/LocationClient';
import { GenericAutocomplete } from '../../../components/others/GenericAutocomplete';
import { Contacts } from '@mui/icons-material';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { useForm } from '../../../hooks/useForm';
import { Dialog } from '../../../components/others/Dialog';
import { ensureArray } from '../../../utils/validateResponseApi';

const initialData = {
    id_company: "",
    type_identification: '',
    identification: '',
    last_name: '',
    identification_digit: '',
    business_name: '',
    supplier_tax_scheme: '',
    supplier_tax_level_code: [],
    location: [],
    contacts: [],
    category: '',
    segment: '',
    additional_fields: ''
}

export const SupplierForm = ({ dto, errorInputs, clients, handleInputChange, handleDirectInputChange, t }) => {
    const createClientRef = useRef();
    const locationRef = useRef();
    const [sendNotification] = useNotification();
    const [offices, setOffices] = useState([]);
    const [id_supplier, setid_supplier] = useState(null);
    const [openCreateClient, setOpenCreateClient] = useState(false);
    const [{ userSession }] = useDataAuth();
    const [clientData, handleInputclientData, handleDirectInputclientData, setAllInfo] = useForm(initialData);

    useEffect(() => {
        if (offices.length === 1) {
            handleDirectInputChange('id_office_supplier', offices[0].code);
        }
    }, [offices]);

    const handleChange = (e) => {
        const { value } = e.target;
        const client = clients.find(c => c.code === value);
        console.log("client ", client);
        handleDirectInputChange('id_company_supplier', client?.code || '');
        handleDirectInputChange('company_supplier_name', client?.code || '');
        if (client) {
            setid_supplier(client.id_client);
            handleFetchOffices(client.id_client)
        } else {
            setAllInfo({});
            setid_supplier(null);
            handleDirectInputChange('id_office_supplier', '');
        }
    };

    const handleCreateClient = () => setOpenCreateClient(true);
    const handleFetchOffices = async (idSupplier) => {
        const response = await fetchOffices(idSupplier, userSession.token);
        if (ensureArray(response?.data).length === 0) {
            handleDirectInputChange('id_office_supplier', '');
            setOffices([]);
            return
        };
        setOffices(response.data);
        if (response.data.length === 1)
            handleDirectInputChange('id_office_supplier', response.data[0].code);
    }

    const Cancel = () => setOpenCreateClient(false);
    const handleSubmit = async (event) => {
        event.preventDefault();
        const isValidCreateClientRef = createClientRef.current?.validateForm();
        const data = JSON.stringify(clientData);
        if (isValidCreateClientRef) {
            if (id_supplier !== null) {
                await updateClient(data, userSession.token);
                sendNotification({ msg: "Cliente actualizado exitosamente.", variant: "success" });
                Cancel();
            } else {
                const response = await insertDataClient(data, userSession.token);
                sendNotification({ msg: "Cliente creado exitosamente.", variant: "success", });
                Cancel();
                if (response?.data) {
                    const dto = response.data;
                    handleDirectInputChange('id_company_supplier', clientData.identification);
                    // handleDirectInputChange('company_supplier_name', clientData.);
                    handleFetchOffices(dto.id);
                }
            }
        } else {
            sendNotification({
                msg: "Por favor complete todos los campos requeridos",
                variant: "error",
            });
        }
    };

    useEffect(() => {
        const fetchClientData = async () => {
            try {
                if (id_supplier) {
                    const response_location = await fetchClientOfficeId(userSession.token, id_supplier);
                    const response = await fetchClientById(userSession.token, id_supplier);
                    if (response.status === 200 && response.data) {
                        const clientDto = response.data;
                        clientDto.id_client = id_supplier;
                        clientDto.location = response_location.status === 200 ? response_location.data || [] : [];
                        clientDto.contacts = clientDto.contacts ? clientDto.contacts.split(',').filter(c => c) : [];
                        setAllInfo(clientDto);
                    }
                }
            } catch (e) {
                console.error("Error fetching data ", e);
            }
        };

        if (openCreateClient) {
            fetchClientData();
        }
    }, [openCreateClient, id_supplier, userSession.token]);

    return (
        <Box sx={{ width: "100%", mx: "auto", mt: 3, mb: 2 }}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <GenericAutocomplete
                        options={clients}
                        value={dto.id_company_supplier}
                        label={t('commonFields.nit')}
                        name="id_company_supplier"
                        required={true}
                        onChange={handleChange}
                        error={Boolean(errorInputs.id_company_supplier?.isError)}
                        helperText={errorInputs.id_company_supplier?.messageError}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 1 }} sx={{ display: 'flex', justifyContent: 'flex-start', padding: 0 }}>
                    <Tooltip title={t("add")} placement="top" arrow>
                        <IconButton
                            aria-label="add"
                            onClick={handleCreateClient}
                        >
                            <Contacts color="primary" />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid size={{ xs: 12, md: 5 }} />
                <Grid size={{ xs: 12, md: 6 }}>
                    <GenericAutocomplete
                        options={offices}
                        value={dto.id_office_supplier}
                        label={t('commonFields.office')}
                        name="id_office_supplier"
                        onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        fullWidth
                        size="small"
                        label={t('commonFields.location.addressDelivery')}
                        name="address_delivery"
                        value={dto.address_delivery}
                        onChange={handleInputChange}
                    />
                </Grid>

                <Dialog
                    openDialog={openCreateClient}
                    widthDialog={"md"}
                    content={
                        <>
                            <CreateFormClient
                                ref={createClientRef}
                                dto={clientData}
                                handleInputclientData={handleInputclientData}
                                handleDirectInputclientData={handleDirectInputclientData}
                            />
                            <Box sx={{ mb: 3 }} />
                            <DividerGradient />
                            <LocationClient
                                ref={locationRef}
                                dto={clientData}
                                handleDirectInputclientData={handleDirectInputclientData}
                            />
                        </>
                    }
                    actions={
                        <ActionButtons
                            onCancel={Cancel}
                            onSubmit={handleSubmit}
                        />
                    }
                />

            </Grid>
        </Box>
    )
}
